/**
 *
 * @param {string} hexCode  => #fbafff
 * @param {number} opacity  => 1, 0, 0.6
 * @returns {Object} {string, array}
 * string: rgba(251,175,255,1)
 * array: [251,175,255,1]
 *
 */

const convertHexToRgbA = (hexCode, opacity = 1) => {
  if (!hexCode) { return null }

  let hex = hexCode.replace('#', '')
  if (hex.length === 3) {
    hex = `${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`
  }

  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  if (opacity > 1 && opacity <= 100) {
    opacity = opacity / 100
  }

  return {
    string: `rgba(${r},${g},${b},${opacity})`,
    array: [r, g, b, opacity]
  }
}
export default convertHexToRgbA
